<script lang="ts">
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { defineComponent } from 'vue';

export default defineComponent({
    components: {},
    data() {
        return {
            // 1. Inicializamos con valores por defecto que no dependen del navegador.
            windowWidth: 0,
            isDesktop: false, 
            campuses: [
                {
                    image: '/pagesImages/slide-escritorio-cree-en-ti-blanco.webp',
                    image2: '/pagesImages/slide-movil-cree-en-ti.webp',
                    type: 'Cree ',
                    name: 'en ti',
                    address: '',
                    visitLink: '',
                },
                {
                    image: '/pagesImages/Home-Riviera-Maya-Color.webp',
                    image2: '/pagesImages/Home-Riviera-Maya-movil-cielo.webp',
                    type: 'Campus Magno ',
                    name: 'Riviera Maya',
                    address: '',
                    visitLink: 'https://humanitas.edu.mx/campus/riviera-maya',
                },
                {
                    image: '/pagesImages/Slide-Puebla-Torre-elementa.webp',
                    image2: '/pagesImages/Slide-Puebla-Torre-elementa.webp',
                    type: 'Campus Ejecutivo ',
                    name: 'Angelópolis',
                    address: 'Proximamente',
                    visitLink: 'https://humanitas.edu.mx/campus/angelopolis',
                },
                {
                    image: '/pagesImages/Campus_Chihuahua.webp',
                    image2: '/pagesImages/Campus_Chihuahua.webp',
                    type: 'Campus Magno ',
                    name: 'Chihuahua',
                    address: 'Chihuahua, Chihuahua',
                    visitLink: 'https://humanitas.edu.mx/campus/chihuahua',
                },
                {
                    image: '/pagesImages/Campus_Queretaro.webp',
                    image2: '/pagesImages/Campus_Queretaro.webp',
                    type: 'Campus Magno ',
                    name: 'Querétaro',
                    address: 'Juriqilla, Querétaro',
                    visitLink: 'https://humanitas.edu.mx/campus/queretaro',
                },
                {
                    image: '/pagesImages/Campus_Madin.webp',
                    image2: '/pagesImages/Campus_Madin.webp',
                    type: 'Campus Magno ',
                    name: 'Presa Madín',
                    address: 'Estado de México',
                    visitLink: 'https://humanitas.edu.mx/campus/presa-madin',
                },
                {
                    image: '/pagesImages/home-campus-Cancun.webp',
                    image2: '/pagesImages/home-campus-Cancun.webp',
                    type: 'Campus Magno ',
                    name: 'Cancún',
                    address: 'Cancún, Quintana Roo',
                    visitLink: 'https://humanitas.edu.mx/campus/cancun',
                },
                {
                    image: '/pagesImages/Campus_Valle.webp',
                    image2: '/pagesImages/Campus_Valle.webp',
                    type: 'Campus Magno ',
                    name: 'Del Valle',
                    address: 'Ciudad de México',
                    visitLink: 'https://humanitas.edu.mx/campus/del-valle',
                },
                {
                    image: '/pagesImages/Campus_Merida.webp',
                    image2: '/pagesImages/Campus_Merida.webp',
                    type: 'Campus Magno ',
                    name: 'Mérida',
                    address: 'Mérida, Yucatán',
                    visitLink: 'https://humanitas.edu.mx/campus/merida',
                },
                {
                    image: '/pagesImages/Campus_Reyes.webp',
                    image2: '/pagesImages/Campus_Reyes.webp',
                    type: 'Campus Magno ',
                    name: 'Los Reyes',
                    address: 'Estado de México',
                    visitLink: 'https://humanitas.edu.mx/campus/los-reyes',
                },
                {
                    image: '/pagesImages/Campus_Tijuana.webp',
                    image2: '/pagesImages/Campus_Tijuana.webp',
                    type: 'Campus Magno ',
                    name: 'Tijuana',
                    address: 'Tijuana, BC.',
                    visitLink: 'https://humanitas.edu.mx/campus/tijuana',
                },
                
                {
                    image: '/pagesImages/Campus_SantaFe.webp',
                    image2: '/pagesImages/Campus_SantaFe.webp',
                    type: 'Campus Ejecutivo ',
                    name: 'Santa Fe',
                    address: 'Ciudad de México',
                    visitLink: 'https://humanitas.edu.mx/campus/santa-fe',
                },
                {
                    image: '/pagesImages/Campus_Guadalajara.webp',
                    image2: '/pagesImages/Campus_Guadalajara.webp',
                    type: 'Campus Ejecutivo ',
                    name: 'Guadalajara',
                    address: 'Guadalajara, Jalisco',
                    visitLink: 'https://humanitas.edu.mx/campus/guadalajara',
                },
                {
                    image: '/pagesImages/home-campus-Virtual-col.webp',
                    image2: '/pagesImages/home-campus-Virtual-col.webp',
                    type: 'Campus Virtual',
                    name: 'Internacional',
                    address: 'Bogotá, Col.',
                    visitLink: 'https://humanitas.edu.mx/campus/virtual',
                },
                {
                    image: '/pagesImages/home-campus-Monterrey.webp',
                    image2: '/pagesImages/home-campus-Monterrey.webp',
                    type: 'Campus Ejecutivo ',
                    name: 'Monterrey',
                    address: '',
                    visitLink: 'https://humanitas.edu.mx/campus/monterrey',
                },
                
                
            ],
            currentCampus: 0,
            currentImage: '',
            timer: null as number | null, // Mejor tipado para el timer
            resizeTimeout: null as number | null,
            observer: null as IntersectionObserver | null,
            isVisible: false,
        };
    },
    computed: {
  currentCampusData(): any {
    return this.campuses[this.currentCampus];
  },
},

methods: {
  handleResize() {
    if (this.resizeTimeout) return;

    this.resizeTimeout = window.setTimeout(() => {
      this.isDesktop = window.innerWidth >= 768;
      this.resizeTimeout = null;
    }, 150);
  },

  changeCampus(index: number): void {
    this.currentCampus = index;
  },

  startTimer(): void {
    if (this.timer) return; // evita duplicados

    this.timer = window.setInterval(() => {
      if (document.hidden || !this.isVisible) return;

      const nextIndex = (this.currentCampus + 1) % this.campuses.length;
      this.currentCampus = nextIndex;
    }, 5000);
  },

  stopTimer(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  initObserver() {
    const el = this.$refs.carousel as HTMLElement;
    if (!el) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting) {
          this.isVisible = true;
          this.startTimer();
        } else {
          this.isVisible = false;
          this.stopTimer();
        }
      },
      { threshold: 0.5 }
    );

    this.observer.observe(el);
  },
},

mounted() {
  this.handleResize();
  window.addEventListener('resize', this.handleResize);

  this.initObserver(); // 👈 reemplaza startTimer
},

beforeUnmount() {
  window.removeEventListener('resize', this.handleResize);
  this.stopTimer();

  if (this.observer) {
    this.observer.disconnect();
  }
},
});
</script>

<template>
    <div ref="carousel" class="relative mb-12 carousel-container h-[calc(100dvh-88px)] lg:h-[calc(100dvh-140px)]">
        <transition name="fade">
            <div :key="currentCampus" class="active flex h-[calc(100dvh-88px)] lg:h-[calc(100dvh-140px)] flex-col items-center justify-center">
                <picture>
                    <source
                        media="(max-width: 767px)"
                        :srcset="`
                        ${currentCampusData.image2}?w=480  480w,
                        ${currentCampusData.image2}?w=640  640w,
                        ${currentCampusData.image2}?w=768  768w,
                        ${currentCampusData.image2}?w=1280 1280w
                        `"
                        sizes="100vw"
                    >
                    <source
                        media="(min-width: 768px)"
                        :srcset="`
                        ${currentCampusData.image2}?w=1280 1280w,
                        ${currentCampusData.image}?w=1920 1920w,
                        ${currentCampusData.image}?w=2560 2560w,
                        ${currentCampusData.image}?w=3840 3840w
                        `"
                        sizes="100vw"
                    >
                    
                    <img
                        :src="`${currentCampusData.image}?w=1920`"
                        :alt="currentCampusData.type + ' ' + currentCampusData.name"
                        class="object-cover object-center h-[calc(100dvh-88px)] lg:h-[calc(100dvh-140px)] w-screen"
                        :loading="currentCampus === 0 ? 'eager' : 'lazy'"
                        :fetchpriority="currentCampus === 0 ? 'high' : 'auto'"
                        decoding="async"
                    />
                </picture>
                <div class="absolute  text-center pt-14 md:text-left text-white z-10 w-full max-w-4xl lg:max-w-6xl flex flex-col lg:justify-center justify-start items-center lg:items-start ">
                    <h2 
                        class="lg:text-3xl text-xl uppercase whitespace-nowrap mb-3 "
                        style="letter-spacing: 10px; text-shadow: 1px 1px 0px black, -1px 1px 0px black, 1px -1px 0px black, -1px -1px 0px black, 0 4px 6px rgba(0, 0, 0, 1);">
                        <span v-if="currentCampusData.type == 'Campus Ejecutivo ' || currentCampusData.type == 'Campus Virtual'" class="block lg:text-3xl text-[16px] whitespace-nowrap">{{ currentCampusData.type }}</span>
                        <span v-show="currentCampus != 0" v-else class="block lg:text-3xl text-xl whitespace-nowrap">{{ currentCampusData.type }}</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span v-show="currentCampus != 0" class="block lg:text-5xl text-3xl whitespace-nowrap">{{ currentCampusData.name }}</span>
                    </h2>
                    <a :href="currentCampusData.visitLink" v-if="currentCampusData.visitLink !== ''" target="_blank">
                        <button class="flex items-center focus:outline-none justify-center bg-white/90 rounded-none hover:bg-white/60 lg:text-[24px] text-[#881912] border-[1.5px] border-[#881912] w-[140px] h-[35px] lg:w-[210px] lg:h-[50px] transition duration-300 ease-in-out">
                            <span>Vis&iacute;tanos</span>
                        </button>
                    </a>
                    <p class="lg:text-2xl text-[18px] lg:h-[50px] h-[35px] lg:mt-4 mt-8 uppercase" style="letter-spacing: 10px; text-shadow: 1px 1px 0px black, -1px 1px 0px black,1px -1px 0px black, -1px -1px 0px black, 0 4px 6px rgba(0, 0, 0, 1); 
                    " v-else>{{currentCampusData.address}}</p>
                </div>
            </div>
        </transition>
        <div class="flex relative -top-12 justify-center mt-4 md:space-x-3 space-x-2">
            <span
                v-for="(_dot, index) in campuses"
                :key="index"
                :class="{ 'bg-gray-400': index !== currentCampus, 'bg-[#881912]': index === currentCampus }"
                class="h-2 w-2 rounded-full cursor-pointer"
                @click="changeCampus(index)"
            ></span>
        </div>
    </div>
</template>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s ease-in-out;
        }
        .fade-enter, .fade-leave-to {
        opacity: 0;
        position: absolute;
        }
        .carousel-container {
            position: relative;
            overflow: hidden;
        }
        .carousel-container img {
            object-fit: cover; /* Mantiene la imagen cubierta sin desbordar */
    }
</style>


